import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Collapse, Tooltip } from '@mui/material';

const Abouthunt = () => {
  const [openHunt1, setOpenHunt1] = useState(false);
  const [openHunt2, setOpenHunt2] = useState(false);
  const [openHunt3, setOpenHunt3] = useState(false);
  const [openHunt4, setOpenHunt4] = useState(false);
  const [openHunt5, setOpenHunt5] = useState(false);
  const [openHunt6, setOpenHunt6] = useState(false);
  return (
    <Box
      id="packages-section"
      component="section"
      sx={{
        background:
          'linear-gradient(to Top,rgb(82, 82, 82) 0%,rgb(106, 106, 106) 100%)',
        color: 'white',
        borderRadius: 2,
        p: 4, // Added padding
        mb: 15,
      }}
    >
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" className="myh2" color="white" mb={2}>
            Hunts Include
          </Typography>
          <Typography mt={7} variant="body1" color="white" textAlign={'left'}>
            <ul>
              <li>
                Complimentary Lodging and Meals for a comfortable, all-inclusive
                experience
              </li>
              <li>Full-Time Cook on Duty preparing hearty meals daily</li>
              <li>
                Expert Guides Available to assist with tracking, retrieving, and
                cleaning game
              </li>
              <li>
                Video Hunt Options to capture unforgettable hunting memories
              </li>
              <li>Group Discounts available for parties of 6 or more</li>
              <li>Bow Hunting Trips Available (for Deer Hunts)</li>
            </ul>
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" className="myh2" color="white" mb={2}>
            Deer Hunts:
          </Typography>
          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              md={6}
              mt={5}
              sx={{
                border: openHunt1 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt1(!openHunt1)}
                  sx={{ cursor: 'pointer' }}
                >
                  2-Day Hunt
                </Typography>
              </Tooltip>
              <Collapse in={openHunt1}>
                <Typography variant="body1" color="white" textAlign="left">
                  <ul>
                    <li>
                      <b>$1,400</b> Total
                    </li>
                    <li>
                      <b>$1450</b> During Rut Season (Thanksgiving through
                      season end)
                    </li>
                    <li>
                      Note: 2-Day Hunts cannot be booked on weekends during rut
                      season. A minimum 3-day booking is required for weekend
                      rut hunts.
                    </li>
                  </ul>
                </Typography>
              </Collapse>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                border: openHunt2 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt2(!openHunt2)}
                  sx={{ cursor: 'pointer' }}
                >
                  3-Day Hunt
                </Typography>
              </Tooltip>
              <Collapse in={openHunt2}>
                <Typography variant="body1" color="white" textAlign="left">
                  <li>
                    <b>$1,650</b> Total
                  </li>
                  <li>
                    <b>$1,850</b> During Rut Season (Thanksgiving through season
                    end)
                  </li>
                </Typography>
              </Collapse>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                border: openHunt3 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt3(!openHunt3)}
                  sx={{ cursor: 'pointer' }}
                >
                  Your Deer Hunt Package Includes
                </Typography>
              </Tooltip>
              <Collapse in={openHunt3}>
                <Typography variant="body1" color="white" textAlign="left">
                  <ul>
                    <li>One Doe and One Trophy Buck</li>
                    <li>
                      Additional Buck: If a second buck is harvested, an
                      additional $750 trophy fee applies.
                    </li>
                    <li>
                      Rut Hunts are from Thanksgiving to end of Hunting Season
                    </li>
                  </ul>
                </Typography>
              </Collapse>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" className="myh2" color="white" mb={2}>
            Turkey Hunts
          </Typography>
          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              md={6}
              mt={5}
              sx={{
                border: openHunt4 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt4(!openHunt4)}
                  sx={{ cursor: 'pointer' }}
                >
                  2-Day Hunt
                </Typography>
              </Tooltip>
              <Collapse in={openHunt4}>
                <Typography variant="body1" color="white" textAlign="left">
                  <ul>
                    <li>
                      <b>$1500</b> Total (Includes 1 Bird)
                    </li>
                    <li>
                      Each Additional Turkey: $500 – includes field dressing and
                      guide assistance
                    </li>
                  </ul>
                </Typography>
              </Collapse>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                border: openHunt5 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt5(!openHunt5)}
                  sx={{ cursor: 'pointer' }}
                >
                  3-Day Hunt
                </Typography>
              </Tooltip>
              <Collapse in={openHunt5}>
                <Typography variant="body1" color="white" textAlign="left">
                  <ul>
                    <li>
                      <b>$2000</b> Total (Includes 2 Birds)
                    </li>
                    <li>
                      Harvest up to 2 wild turkeys with no additional trophy
                      fees
                    </li>
                    <li>
                      Perfect for serious hunters seeking an immersive and
                      successful turkey hunting experience
                    </li>
                  </ul>
                </Typography>
              </Collapse>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                border: openHunt6 ? 'none' : '1px solid white',
                borderRadius: 2,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <Tooltip
                title="Click to view what's included in the deer hunt package"
                arrow
              >
                <Typography
                  variant="h6"
                  color="white"
                  onClick={() => setOpenHunt6(!openHunt6)}
                  sx={{ cursor: 'pointer' }}
                >
                  Your Turkey Hunt Package Includes:
                </Typography>
              </Tooltip>
              <Collapse in={openHunt6}>
                <Typography variant="body1" color="white" textAlign="left">
                  <ul>
                    <li>
                      Guided Turkey Hunts – expert guides will assist you
                      throughout the hunt
                    </li>
                    <li>
                      Call Your Own Turkeys – hunters are welcome to call their
                      own turkeys if desired
                    </li>
                    <li>
                      2-Day Minimum Requirement – all turkey hunts require at
                      least 2 days
                    </li>
                    <li>
                      50% Non-Refundable Deposit – required to secure your spot
                    </li>
                    <li>
                      Any Turkey 'Shot At' Counts – as part of your package
                    </li>
                  </ul>
                </Typography>
              </Collapse>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Abouthunt;
